module.exports = __webpack_public_path__ + "static/media/link-account-1.fe91f849.mp3";